import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Config from "conFig.js";
import { Error, Success } from "../../../../assets/jss/util/messageUtil";
import { isLessThanDay } from "../../../../assets/jss/util/validateUtil";

const Themgiaypheplaixe = React.memo(function Themgiaypheplaixe(props) {
  const { laixe_id } = props;
  const [sogplx, setSogplx] = React.useState("");
  const [hanggplx, setHanggplx] = React.useState([]);
  const [hanggplxid, setHanggplxid] = React.useState("");
  const [ngaycap, setNgaycap] = React.useState(dayjs());
  const [ngayhethan, setNgayhethan] = React.useState(dayjs());
  const [alert, setAlert] = React.useState(false);
  const [alert1, setAlert1] = React.useState(false);
  const [alertValidate, setAlertValidate] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  //const [disableBT, setDisableBT] = React.useState(true);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gethanggplx = () => {
    var url = Config.backend + "/api/Donvi/getdmhanggplx?username=" + username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHanggplx(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const themgiayphep = () => {
    let mess = validateThem();
    if (mess === Success.SC0001) {
      var ngaycapgp =
        ngaycap.$y +
        "-" +
        String(ngaycap.$M + 1).padStart(2, "0") +
        "-" +
        ngaycap.$D;
      var ngayhan =
        ngayhethan.$y +
        "-" +
        String(ngayhethan.$M + 1).padStart(2, "0") +
        "-" +
        ngayhethan.$D;
      var url = Config.backend + "/api/Donvi/themlaixegplx";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          laixe_id: laixe_id,
          sogplx: sogplx,
          hanggplx: hanggplxid,
          ngaycap: ngaycapgp,
          ngayhethan: ngayhan,
          username: username,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data === 1) {
            showNotification();
          } else showNotification1();
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      setMessageValidate(mess);
      showNotificationValidate();
    }
  };
  const showNotificationValidate = () => {
    setAlertValidate(true);
    setTimeout(function () {
      setAlertValidate(false);
    }, 6000);
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  const showNotification1 = () => {
    setAlert1(true);
    setTimeout(function () {
      setAlert1(false);
    }, 2000);
  };
  const validateThem = () => {
    // Kiem tra ngay cap GPLX va ngay het han GPLX
    if (isLessThanDay(ngayhethan, ngaycap)) {
      return Error.ER0056;
    }
    // Kiem tra cac truong bat buoc nhap
    if (sogplx.trim() === "") {
      return Error.ER0057;
    }
    if (!hanggplxid || hanggplxid === "") {
      return Error.ER0058;
    }
    return Success.SC0001;
  };
  React.useEffect(() => {
    gethanggplx();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <TextField
                label="Số giấy phép lái xe"
                variant="outlined"
                size="small"
                value={sogplx}
                onChange={(event) => {
                  setSogplx(event.target.value);
                }}
                InputLabelProps={{
                  sx: {
                    color: "red",
                  },
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <Autocomplete
                freeSolo
                disableClearable
                size="small"
                options={hanggplx}
                getOptionLabel={(option) => option.ten}
                onChange={(event, value) => {
                  setHanggplxid(value.ma);
                }}
                onInputChange={(event, newInputValue, reason) => {
                  if (reason !== "reset") {
                    setHanggplxid(null);
                  } else {
                    setHanggplxid(
                      hanggplx.find(({ ten }) => ten === newInputValue).ma
                    );
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Hạng giấy phép lái xe"
                    InputLabelProps={{
                      sx: {
                        color: "red",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      type: "search",
                      style: {
                        height: "35px",
                        paddingTop: "initial",
                      },
                    }}
                  />
                )}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày cấp"
                  value={ngaycap}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaycap(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: "10px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày hết hạn"
                  value={ngayhethan}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgayhethan(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "20px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          //disabled={disableBT}
          onClick={themgiayphep}
        >
          Thêm
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Thêm thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Có lỗi trong quá trình thêm"
            open={alert1}
            closeNotification={() => setAlert1(false)}
            close
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alertValidate}
            closeNotification={() => setAlertValidate(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Themgiaypheplaixe.propTypes = {
  laixe_id: PropTypes.number,
};
export default Themgiaypheplaixe;
